import { LangText } from '@/components';
import { preFixImgUrl } from '@/utils';

const CTA_BG = preFixImgUrl('2ffdb1591c4cbd672164ac93154dbeee.png');
const PHONE_IMAGE = preFixImgUrl('b3ead438580208ae7d0b3eb330d134d7.png');
const QR_CODE_IMAGE = preFixImgUrl('20c61a1a949b9452ffaf0c38bd6107db.png');

export const HomeAppCta = () => {
  return (
    <section
      className="h-[638px] w-full bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${CTA_BG})`,
      }}
    >
      <div className="mx-auto flex h-full w-[1460px] items-end">
        <img src={PHONE_IMAGE} alt="" className="h-[560px] w-auto shrink-0 object-contain" draggable={false} />

        <div className="mb-[80px] text-white">
          <LangText lngKey="home.appCta.titleLine1" className="block text-[36px] font-bold leading-[48px]" />
          <LangText lngKey="home.appCta.titleLine2" className="mt-[8px] block text-[36px] font-bold leading-[48px]" />

          <LangText lngKey="home.appCta.descLine1" className="mt-[20px] block text-[24px] leading-[30px]" />
          <LangText lngKey="home.appCta.descLine2" className="mt-[12px] block text-[24px] leading-[30px]" />

          <img src={QR_CODE_IMAGE} alt="" className="mt-[38px] h-[174px] w-[174px] rounded-[12px] object-contain" draggable={false} />
        </div>
      </div>
    </section>
  );
};
